import React from "react";
import Header from "../Comoponents/Header";
import Footer from "../Comoponents/Footer";
import { useTranslation, Trans } from "react-i18next";

function PrivacyPolicy() {
    const { t, i18n } = useTranslation();
  return (
    <>
    
    <Header/>
    {/* <div className="privacy-policy">
         <div className="container">
      <h1>Privacy Policy</h1>   
    

      <section>
  <h2>1. Introduction</h2>
  <p>
    Welcome to TaraRide("we", "our", "us"). We are committed to protecting your privacy and ensuring that your personal data is handled in a safe and responsible manner. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you access or use our ride-booking platform and related services in the Arab Republic of Egypt.
  </p>
  <p>
    By using our services, you agree to the collection and use of information in accordance with this Privacy Policy. We process your personal data in compliance with applicable Egyptian data protection laws, including the Egypt Personal Data Protection Law No. 151 of 2020.
  </p>
</section>

<section>
  <h2>2. Information We Collect</h2>
  <p>
    We may collect and process different types of personal data depending on how you interact with our platform. This includes personal identification information such as your full name, email address, and mobile number. We also collect location data including real-time GPS location, pickup and drop-off addresses, and route information for providing ride services.
  </p>
  <p>
    Additionally, we collect trip-related data such as ride history, driver details, timestamps, and transaction records. Device-related information such as IP address, browser type, operating system, and usage behavior may also be collected for analytics and system improvement purposes. Payment-related data is processed securely through third-party payment providers.
  </p>
</section>

<section>
  <h2>3. How We Use Your Information</h2>
  <p>
    Your personal data is used to provide, manage, and improve our services. This includes facilitating ride bookings, connecting riders with drivers, processing payments, and sending confirmations or receipts. We also use your information to enhance user experience, improve application performance, and develop new features.
  </p>
  <p>
    Furthermore, your data may be used for customer support, communication regarding updates or promotions, and ensuring platform safety. We also process data to prevent fraudulent activities, enforce our terms, and comply with legal and regulatory requirements.
  </p>
</section>

<section>
  <h2>4. Legal Basis for Processing</h2>
  <p>
    We process your personal data based on several legal grounds, including your consent, the necessity to perform a contract (such as providing ride services), compliance with legal obligations, and our legitimate business interests. All processing activities are carried out in accordance with Egyptian laws and regulations.
  </p>
</section>

<section>
  <h2>5. Data Sharing and Disclosure</h2>
  <p>
    We may share your personal data with drivers to complete ride services and ensure smooth operations. Your information may also be shared with payment service providers for secure transaction processing. Additionally, we may disclose your data to government authorities, law enforcement agencies, or regulatory bodies when required by applicable laws in Egypt.
  </p>
  <p>
    We may also engage trusted third-party service providers for hosting, analytics, and technical support. These parties are contractually obligated to handle your data securely and only for specified purposes. We do not sell or rent your personal data to third parties.
  </p>
</section>

<section>
  <h2>6. Data Security</h2>
  <p>
    We implement appropriate technical and organizational security measures to protect your personal data from unauthorized access, loss, misuse, or alteration. These measures include encryption, secure servers, and access control mechanisms.
  </p>
  <p>
    While we strive to ensure a high level of security, no method of transmission over the internet or electronic storage is completely secure. Therefore, we cannot guarantee absolute security, and users are advised to take necessary precautions.
  </p>
</section>

<section>
  <h2>7. Data Retention</h2>
  <p>
    We retain your personal data only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, including providing services and complying with legal obligations. Retention periods may vary based on the type of data and applicable laws.
  </p>
  <p>
    Once your data is no longer required, it is securely deleted or anonymized in accordance with our data retention policies.
  </p>
</section>

<section>
  <h2>8. Your Rights</h2>
  <p>
    Under applicable Egyptian data protection laws, you have the right to access your personal data, request correction of inaccurate information, and request deletion of your data where legally permissible. You may also object to or restrict certain processing activities.
  </p>
  <p>
    To exercise your rights, you may contact us using the details provided below. We will respond to your request in accordance with applicable legal requirements.
  </p>
</section>

<section>
  <h2>9. Children's Privacy</h2>
  <p>
    Our services are not intended for individuals under the age of 18. We do not knowingly collect or process personal data from minors. If we become aware that we have collected such data, we will take appropriate steps to delete it promptly.
  </p>
</section>

<section>
  <h2>10. Cookies and Tracking Technologies</h2>
  <p>
    We use cookies and similar tracking technologies to enhance user experience, analyze platform usage, and improve our services. Cookies help us understand user behavior and optimize our application accordingly.
  </p>
  <p>
    You may choose to disable cookies through your browser settings; however, this may affect certain functionalities of the platform.
  </p>
</section>

<section>
  <h2>11. Changes to This Privacy Policy</h2>
  <p>
    We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on this page with an updated revision date. Users are encouraged to review this policy periodically.
  </p>
  <p>
    Continued use of our services after any changes indicates your acceptance of the updated policy.
  </p>
</section>
      <section>
        <h2>10. Contact Us</h2>
        <p className="m-0">
  <a
    href="mailto:info@tararide.com"
    style={{ color: "#fff", textDecoration: "none" }}
  >
    info@tararide.com
  </a>
</p>

<p>
  Phone:{" "}
  <a
    href="tel:+201287690960"
    style={{ color: "#fff", textDecoration: "none" }}
  >
    +20 1287690960
  </a>
</p>
      </section>
    </div>
    </div> */}

     <div className="privacy-policy">
  <div className="container">

    <h1>{t("privacy.title")}</h1>

    {/* 1 */}
    <section>
      <h2>{t("privacy.sec1.title")}</h2>
      <p>{t("privacy.sec1.p1")}</p>
      <p>{t("privacy.sec1.p2")}</p>
    </section>

    {/* 2 */}
    <section>
      <h2>{t("privacy.sec2.title")}</h2>
      <p>{t("privacy.sec2.p1")}</p>
      <p>{t("privacy.sec2.p2")}</p>
    </section>

    {/* 3 */}
    <section>
      <h2>{t("privacy.sec3.title")}</h2>
      <p>{t("privacy.sec3.p1")}</p>
      <p>{t("privacy.sec3.p2")}</p>
    </section>

    {/* 4 */}
    <section>
      <h2>{t("privacy.sec4.title")}</h2>
      <p>{t("privacy.sec4.p1")}</p>
    </section>

    {/* 5 */}
    <section>
      <h2>{t("privacy.sec5.title")}</h2>
      <p>{t("privacy.sec5.p1")}</p>
      <p>{t("privacy.sec5.p2")}</p>
    </section>

    {/* 6 */}
    <section>
      <h2>{t("privacy.sec6.title")}</h2>
      <p>{t("privacy.sec6.p1")}</p>
      <p>{t("privacy.sec6.p2")}</p>
    </section>

    {/* 7 */}
    <section>
      <h2>{t("privacy.sec7.title")}</h2>
      <p>{t("privacy.sec7.p1")}</p>
      <p>{t("privacy.sec7.p2")}</p>
    </section>

    {/* 8 */}
    <section>
      <h2>{t("privacy.sec8.title")}</h2>
      <p>{t("privacy.sec8.p1")}</p>
      <p>{t("privacy.sec8.p2")}</p>
    </section>

    {/* 9 */}
    <section>
      <h2>{t("privacy.sec9.title")}</h2>
      <p>{t("privacy.sec9.p1")}</p>
    </section>

    {/* 10 */}
    <section>
      <h2>{t("privacy.sec10.title")}</h2>
      <p>{t("privacy.sec10.p1")}</p>
      <p>{t("privacy.sec10.p2")}</p>
    </section>

    {/* 11 */}
    <section>
      <h2>{t("privacy.sec11.title")}</h2>
      <p>{t("privacy.sec11.p1")}</p>
      <p>{t("privacy.sec11.p2")}</p>
    </section>

    {/* CONTACT */}
    <section>
      <h2>{t("privacy.contact.title")}</h2>

      <p className="m-0">
        <a href="mailto:info@tararide.com">
          info@tararide.com
        </a>
      </p>

      <p>
        {t("privacy.contact.phone")}:{" "}
        <a href="tel:+201287690960">
          +20 1287690960
        </a>
      </p>
    </section>

  </div>
</div>

    
    <Footer/>
    </>
   
  );
}


export default PrivacyPolicy;